import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { BookCatalogView } from './components/BookCatalogView';
import { AdminPanel } from './components/AdminPanel';
import { ExemplarStockView } from './components/ExemplarStockView';

function App(): React.ReactElement {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<BookCatalogView />} />
        <Route path="/estoque" element={<ExemplarStockView />} />
        <Route path="/admin" element={<AdminPanel />} />
      </Routes>
    </Router>
  );
}

export default App;
